<template>
  <div>
    <v-dialog v-model="otpverificarionNumber" persistent width="390px">
      <v-card class="overflow-hidden">
        <v-toolbar dense class="gradient-bg elevation-0 white--text">
          <v-toolbar-title>Phone Number Verification</v-toolbar-title
          ><v-spacer />
          <v-icon @click="close_dialog()" class="white--text mr-n3"
            >mdi-close</v-icon
          >
        </v-toolbar>
        <v-card-text class="mt-4">
          <v-form ref="form">
            <label class="ml-7 font-weight-medium">Enter PhoneNumber OTP</label>
            <v-otp-input
              v-model="phoneCode"
              :rules="otp_rules"
              :key="otpverificarionNumber"
              class="mr-6 ml-6 mt-4"
            />
          </v-form>
          <div class="ml-8 mt-4 font-weight-medium">
            Resend OTP in ({{ timer }}s)
            <v-icon
              v-if="!timerRunning"
              color="#EF6C00"
              class="mb-2 ml-2"
              id="sign-in-button"
              @click="restartTimer"
              >mdi-refresh</v-icon
            >
          </div>

          <!-- @finish="submitcode()" -->
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            small
            class="gradient-bg white--text mb-2 ml-2"
            @click="verifyversion2"
            :loading="phloading"
            id="sign-in-button"
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import { GetCurrentUserDetails } from "@/graphql/queries.js";
import { GenVerifyOtp, createOrg } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";

// import { Auth } from "aws-amplify";

export default {
  props: {
    otpverificarionNumber: Boolean,
    phoneitems: Object,
    sessiondata: String,
    onboardItems: Object,
  },
  data() {
    return {
      Getorgcurrent: {},
      GetCurrentUserObject2: {},
      OtpUserObject: {},
      otp_rules: [
        (v) => /^\d+$/.test(v) || "OTP must contain only numbers",
        (v) => v.length != 0 || "OTP cannot be empty",
        (v) => v.length == 6 || "Enter Correct OTP",
      ],
      timer: 60,
      phloading: false,
      phoneCode: "",
      user_full_contact_number: "",
      timerRunning: false,
      sessiondata2: "",
    };
  },
  watch: {
    otpverificarionNumber: {
      async handler() {
        if (this.otpverificarionNumber == true) {
          this.phoneCode = "";
          this.user_full_contact_number =
            "+" +
            this.onboardItems.user_country_code +
            this.onboardItems.user_contact_number;

          this.startTimer();
          this.sessiondata2 = this.sessiondata;
        }
      },
      immediate: true,
    },
  },
  methods: {
    close_dialog() {
      this.$refs.form.reset();
      this.phoneCode = "";
      this.timer = 60;
      this.timerRunning = false;
      this.$emit("clicked", 2);
    },
    async phoneOTPV2() {
      try {
        let result = await API.graphql(
          graphqlOperation(GenVerifyOtp, {
            input: {
              action_type: "OTP_GENERATOR",
              contact_number: this.user_full_contact_number,
            },
          })
        );
        this.phloading = false;
        var response = JSON.parse(result.data.GenVerifyOtp);
        if (response.Status == "SUCCESS") {
          // console.log(result);
          this.sessiondata2 = result.session;
          this.startTimer();
          this.$store.commit("snackbar/showMessage", {
            content: response.Message,
            color: "green",
          });
        }
        // console.log(response);

        // console.log(this.countrycode.one);
      } catch (err) {
        this.$store.commit("snackbar/showMessage", {
          content: err.errors[0].message,
          color: "red",
        });
      }
    },
    async Onboard() {
      this.phloading = true;
      try {
        let result = await API.graphql(
          graphqlOperation(createOrg, {
            input: this.onboardItems,
          })
        );
        this.phloading = false;
        var response = JSON.parse(result.data.createOrg);
        if (response.Status == "SUCCESS" || response.Status == "SUCCES") {
          this.GetCurrentUserDetailslogin();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: response.Message,
            color: "red",
          });
        }

        // console.log(this.countrycode.one);
      } catch (err) {
        this.$store.commit("snackbar/showMessage", {
          content: err.errors[0].message,
          color: "red",
        });
      }
    },
    async GetCurrentUserDetailslogin() {
      this.phloading = true;
      try {
        let result = await API.graphql(
          graphqlOperation(GetCurrentUserDetails, {
            input: {
              user_email_id: this.onboardItems.user_email_id.toLowerCase(),
            },
          })
        );
        this.phloading = false;
        this.Getorgcurrent = result.data.GetCurrentUserDetails.orgdetails;
        this.GetCurrentUserObject2 =
          result.data.GetCurrentUserDetails.UserDetails;

        this.$store.commit("set_org_user_details", this.GetCurrentUserObject2);
        this.$store.commit("set_org_details", this.Getorgcurrent);
        this.$store.commit("snackbar/showMessage", {
          content: "Login Successful!",
          color: "green",
        });
        this.$router.push("/Dashboard");
      } catch (err) {
        console.log("errorssss get current", err);
        this.$store.commit("snackbar/showMessage", {
          content: err.errors[0].message,
          color: "red",
        });
      }
    },
    async verifyversion2() {
      this.phloading = true;
      try {
        let result = await API.graphql(
          graphqlOperation(GenVerifyOtp, {
            input: {
              action_type: "OTP_VERIFY",
              contact_number: this.user_full_contact_number,
              otp: this.phoneCode,
              session: this.sessiondata2,
            },
          })
        );
        this.phloading = false;
        var response = JSON.parse(result.data.GenVerifyOtp);
        if (response.Status == "SUCCESS") {
          this.Onboard();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: response.Message,
            color: "red",
          });
        }

        // console.log(this.countrycode.one);
      } catch (err) {
        this.$store.commit("snackbar/showMessage", {
          content: err.errors[0].message,
          color: "red",
        });
      }
    },

    startTimer() {
      this.timerRunning = true;
      this.timer = 60;
      this.countdown();
    },

    restartTimer() {
      this.timer = 60;
      this.phoneOTPV2();

      this.timerRunning = true;
    },

    countdown() {
      if (this.timer > 0) {
        setTimeout(() => {
          this.timer--;
          this.countdown();
        }, 1000);
      } else {
        this.timerRunning = false;
      }
    },
  },
};
</script>

<style>
</style>